import React, { useEffect, useState } from "react";
import {
  createTheme,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Alert,
  Skeleton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { themeOptions, theming } from "../../../theme";
import { ThemeProvider } from "@emotion/react";
import MainModal from "../../MainModal";
import ComponentHeader from "../../ComponentHeader";
import CoursesTable from "../CoursesTable";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCourses,
  editCourse,
} from "../../../redux/actions/courses-action";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { BASE_URL } from "../../../constant/apiURL";
import { apiPut } from "../../../utils/apiRequests";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
    "& * > input": {
      padding: "10px !important",
    },
    "& * > select": {
      padding: "3.5px !important",
    },
  },
  addIconButton: {
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  inputLabel: {
    fontWeight: "bold !important",
    top: "5px",
  },

  modalDescription: {
    borderTop: "1px solid #cdcdcd !important",
    padding: "15px",
    marginTop: "20px",
    borderBottom: "1px solid #cdcdcd !important",
  },
}));

const token = localStorage.getItem("token");

export default function CourseList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = createTheme(themeOptions);
  const [open, setOpen] = useState(false);
  const [deleteVisible, setdeleteVisible] = useState(false);
  const [editVisible, seteditVisible] = useState(false);
  const [edit, setedit] = useState(false);
  const [selectedrows, setselectedrows] = useState(null);

  const [name, setName] = useState("");
  const [address, setaddress] = useState("");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [clearRow, setclearRow] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [courseDetailData, setCourseDetailData] = useState();
  const [courseDataAlert, setCourseDataAlert] = useState(false);

  const [addCourse, setAddCourse] = useState({
    name: "",
    address: "",
    latitude: "",
    longitude: "",
    front_9: "",
    back_9: "",
    status: "active",
  });

  //   {states form modal}

  const [status, setStatus] = useState("active");
  const [submit, setSubmit] = useState(false);

  const [editAlert, setEditAlert] = useState(false);
  const [editAlertMsg, setEditAlertMsg] = useState("");

  const navigate = useNavigate();

  const openModal = () => {
    setOpen(true);
  };
  const closeModal = () => {
    setOpen(false);
    setName("");
    setaddress("");
    setlatitude("");
    setlongitude("");
  };

  const onEditPress = () => {
    if (selectedrows) {
      setedit(!edit);
    } else {
      alert("Please Select one item!");
    }
  };

  const onSelectRow = (e) => {
    if (selectedrows != e?.selectedRows?.length) setedit(false);
    setselectedrows(e?.selectedRows[0]);
    setclearRow(false);
  };

  const coursesData = useSelector((state) => state.coursesReducer.data);
  const loadingState = useSelector((state) => state?.coursesReducer);
  const loading = useSelector((state) => state?.courseReducer?.isLoading);

  var courses = coursesData;
  const editCourseData = useSelector((state) => state?.editCourseReducer);

  const [searchText, setSearchText] = useState("");

  if (searchText) {
    courses = coursesData?.filter((val) => {
      if (
        val?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        val?.address?.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return val;
      }
    });
  }

  const _handleOnChangeName = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, name: value });
  };

  const _handleOnChangeAddress = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, address: value });
  };

  const _handleOnChangeLatitude = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, latitude: value });
  };

  const _handleOnChangeLongitude = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, longitude: value });
  };

  const _handleOnChangeFront9 = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, front_9: value });
  };

  const _handleOnChangeBack9 = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, back_9: value });
  };

  const _handleOnChangeStatus = (e) => {
    const { value } = e.target;
    setAddCourse({ ...addCourse, status: value });
  };

  const clearState = () => {
    setName("");
    setaddress("");
    setlatitude("");
    setlongitude("");
  };

  const onSubmit = async () => {
    var dataObj = {
      name: addCourse.name,
      city_id: "62ba2251a45c0fd7e36e067a",
      address: addCourse.address,
      latitude: addCourse.latitude,
      longitude: addCourse.longitude,
      course_combination: [
        {
          combination_name: "Red & Yellow",
          front_9: addCourse.front_9,
          back_9: addCourse.back_9,
        },
      ],
      status: addCourse.status?.toLowerCase(),
    };
    const validate = async () => {
      const isEmpty = Object.keys(dataObj).some(function (x) {
        return dataObj[x] === "" || dataObj[x] === null;
      });
      if (isEmpty) {
        setSubmit(true);
        return false;
      } else {
        setSubmit(false);
        return true;
      }
    };
    const isValid = await validate();
    if (!isValid) return;

    axios
      .put(
        `${BASE_URL}${ApiEndpoints.course.base}${ApiEndpoints.course.add}`,
        dataObj,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setEditAlert(true);

        setCourseDetailData(res?.data);
        if (res?.data?.error == true) {
          setCourseDataAlert(true);
        } else {
          setOpen(false);
          dispatch(getAllCourses());
          dispatch(getAllCourses());
          dispatch(getAllCourses());
        }
      })
      .catch((err) => {});
  };

  const onDeletePress = () => {
    setdeleteVisible(true);
  };

  const onDelete = async () => {
    axios
      .delete(
        `${BASE_URL}${ApiEndpoints.course.base}${ApiEndpoints.course.delete}${selectedrows?._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setCourseDetailData(res?.data);
        setdeleteVisible(false);
        dispatch(getAllCourses());
        dispatch(getAllCourses());
        dispatch(getAllCourses());

        if (res?.data?.error == true) {
          setCourseDataAlert(true);
        }
      })
      .catch((err) => console.log("error ===> ", err));
  };

  const onEdit = async () => {
    var dataObj = {
      name: addCourse.name,
      city_id: "62ba2251a45c0fd7e36e067a",
      address: addCourse.address,
      status: addCourse.status,
      latitude: addCourse.latitude,
      longitude: addCourse.longitude,
      course_combination: [
        {
          combination_name: "Red & Yellow",
          front_9: addCourse.front_9,
          back_9: addCourse.back_9,
        },
      ],
    };
    dispatch(editCourse(selectedrows?._id, dataObj));
    dispatch(getAllCourses());
    dispatch(getAllCourses());
    dispatch(getAllCourses());
    setAddCourse({
      name: "",
      address: "",
      latitude: "",
      longitude: "",
      status: "",
      back_9: "",
      front_9: "",
    });
    setselectedrows(null);
    seteditVisible(false);
    setedit(false);
  };

  const rowPerPage = (e) => {
    setRowsPerPage(e);
  };

  const handleSwitchCourses = (id, value) => {
    const newsSwitchPayload = {
      status: value,
    };

    apiPut(
      `${ApiEndpoints.course.base}${ApiEndpoints.course.update}${id?._id}`,
      newsSwitchPayload,
      (res) => {
        setEditAlertMsg(res?.message);
        setEditAlert(true);

        setTimeout(() => {
          setEditAlert(false);
          setEditAlertMsg("");
        }, 1000);
      },
      (err) => {
        setTimeout(() => {
          setEditAlert(false);
          setEditAlertMsg("");
        }, 1000);
        setEditAlert(true);
        setEditAlertMsg({ showAlert: true, msg: err?.message });
      }
    );
  };

  useEffect(() => {
    dispatch(getAllCourses(1, rowsPerPage));
  }, []);

  useEffect(() => {
    if (editCourseData?.status) {
      setEditAlert(true);
      setEditAlertMsg(editCourseData?.status);
    }
    setTimeout(() => {
      setEditAlert(false);
    }, 5000);
  }, [editCourseData]);

  return (
    <ThemeProvider theme={theme}>
      {/* { parent-container} */}
      <Grid container>
        <Grid item xs={12} p={3}>
          {/* {container} */}
          <Grid item container>
            <Grid item xs={12}>
              <ComponentHeader
                headerTitle="Courses List"
                cbOpenModal={() => {
                  openModal();
                }}
                onSearch={(e) => setSearchText(e)}
              />
            </Grid>
          </Grid>
          {/* {container} */}
          <Grid item container>
            <Grid item xs={12} mt={2}>
              <Stack spacing={1}>
                {editAlert ? (
                  <Alert severity="success">{editAlertMsg}</Alert>
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          </Grid>
          {/* {container} */}
          <Grid item container>
            {/* {container} */}
            <Grid item xs={12} m={2}>
              {loadingState?.loading == false ? (
                <CoursesTable
                  onChangeRowsPerPage={rowPerPage}
                  clearRow={clearRow}
                  progressPending={loading}
                  progressComponent={<CircularProgress color="success" />}
                  data={courses || []}
                  onSelectedRowsChange={onSelectRow}
                  edit={edit}
                  selectedRow={selectedrows}
                  onDeletePress={onDeletePress}
                  setselectedrows={setselectedrows}
                  seteditVisible={seteditVisible}
                  editVisible={editVisible}
                  addCourse={addCourse}
                  setAddCourse={setAddCourse}
                  handleSwitchCourses={handleSwitchCourses}
                />
              ) : (
                <>
                  <Skeleton />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </>
              )}
            </Grid>
          </Grid>

          {/* {modal content} */}
          <MainModal
            show={open}
            closeModal={() => setOpen(false)}
            modalHeadTitle="Create Course"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            cb={() => {
              closeModal();
            }}
            btnCloseModal={() => onSubmit()}
            leftVariant="outlined"
            rightVariant="contained"
            sx={{ display: "flex", alignSelf: "flex-end" }}
            width="900px"
          >
            <Grid container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <InputLabel shrink className={classes.inputLabel}>
                    Name
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeName}
                    value={addCourse.name}
                    required
                    placeholder="Name"
                    className={classes.outlineInputBorder}
                    sx={{
                      "& input": {
                        marginLeft: "35px",
                      },
                    }}
                    fullWidth
                    variant="outlined"
                    error={!name && submit}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          sx={{
                            width: "50px",
                            height: "50px",
                            maxHeight: "48px",
                            backgroundColor: "#06623B",
                            position: "absolute",
                            top: "-5px",
                            left: " 0px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderTopLeftRadius: "5px",
                            borderBottomLeftRadius: "5px",
                          }}
                        >
                          <AccountBoxRoundedIcon
                            size="large"
                            style={{ marginInlineStart: "-9px" }}
                            sx={{
                              fontSize: "30px",
                              color: "white",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    helperText={!name && submit ? "Name is required" : ""}
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Address
                  </InputLabel>

                  <TextField
                    onChange={_handleOnChangeAddress}
                    value={addCourse.address}
                    required
                    placeholder="Address"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                    error={!address && submit}
                    helperText={!address && submit ? "Address is required" : ""}
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Latitude
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeLatitude}
                    value={addCourse.latitude}
                    required
                    placeholder="0.0000"
                    className={classes.outlineInputBorder}
                    fullWidth
                    type={"number"}
                    variant="outlined"
                    error={!latitude && submit}
                    helperText={
                      !latitude && submit ? "Latitude is required" : ""
                    }
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Longitude
                  </InputLabel>
                  <TextField
                    required
                    placeholder="67.1061"
                    className={classes.outlineInputBorder}
                    fullWidth
                    onChange={_handleOnChangeLongitude}
                    value={addCourse.longitude}
                    type={"number"}
                    variant="outlined"
                    error={!longitude && submit}
                    helperText={
                      !longitude && submit ? "Longitude is required" : ""
                    }
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Front 9
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeFront9}
                    value={addCourse.front_9}
                    required
                    placeholder="Front 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Back 9
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeBack9}
                    value={addCourse.back_9}
                    required
                    placeholder="Back 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Status
                  </InputLabel>
                  <Select
                    variant="outlined"
                    onChange={_handleOnChangeStatus}
                    value={addCourse.status}
                    className={classes.outlineInputBorder}
                    name="status"
                    fullWidth
                    label="."
                    placeholder="Active"
                  >
                    {["active", "inactive"].map((item) => (
                      <MenuItem
                        key={item}
                        // setStatus={item.name}
                        value={item}
                        onClick={() => setStatus(item)}
                      >
                        <Grid container item>
                          <Grid
                            fontStyle={{ textTransform: "capitalize" }}
                            item
                            xs={10}
                          >
                            {item}
                          </Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Select>
                  {courseDataAlert && (
                    <Alert variant="filled" severity="error">
                      {courseDetailData?.message}
                    </Alert>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* DELETE MODAL */}
          <MainModal
            show={deleteVisible}
            closeModal={() => setdeleteVisible(false)}
            modalHeadTitle="Delete"
            btnLeftTitle="Ok"
            btnRightTitle="Cancel"
            btnCloseModal={() => setdeleteVisible(false)}
            leftVariant="outlined"
            rightVariant="contained"
            sx={{ display: "none" }}
            width="500px"
            cb={onDelete}
          >
            <Grid item container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <div className={classes.modalDescription}>
                    <p> Are you sure, you want to Delete?</p>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>

          {/* EDIT MODAL */}
          <MainModal
            show={editVisible}
            closeModal={() => seteditVisible(false)}
            modalHeadTitle="Edit Course"
            btnLeftTitle="Save"
            btnRightTitle="Cancel"
            btnCloseModal={() => seteditVisible(false)}
            leftVariant="contained"
            rightVariant="outlined"
            sx={{ display: "none" }}
            width="900px"
            cb={onEdit}
          >
            <Grid container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <InputLabel shrink className={classes.inputLabel}>
                    Name
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeName}
                    value={addCourse.name}
                    required
                    placeholder="Name"
                    className={classes.outlineInputBorder}
                    sx={{
                      "& input": {
                        marginLeft: "35px",
                      },
                    }}
                    fullWidth
                    variant="outlined"
                    error={!name && submit}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          sx={{
                            width: "50px",
                            height: "50px",
                            maxHeight: "48px",
                            backgroundColor: "#06623B",
                            position: "absolute",
                            top: "-5px",
                            left: " 0px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderTopLeftRadius: "5px",
                            borderBottomLeftRadius: "5px",
                          }}
                        >
                          <AccountBoxRoundedIcon
                            size="large"
                            style={{ marginInlineStart: "-9px" }}
                            sx={{
                              fontSize: "30px",
                              color: "white",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    helperText={!name && submit ? "Name is required" : ""}
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Address
                  </InputLabel>

                  <TextField
                    onChange={_handleOnChangeAddress}
                    value={addCourse.address}
                    required
                    placeholder="Address"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                    error={!address && submit}
                    helperText={!address && submit ? "Address is required" : ""}
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Latitude
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeLatitude}
                    value={addCourse.latitude}
                    required
                    placeholder="0.0000"
                    className={classes.outlineInputBorder}
                    fullWidth
                    type={"number"}
                    variant="outlined"
                    error={!latitude && submit}
                    helperText={
                      !latitude && submit ? "Latitude is required" : ""
                    }
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Longitude
                  </InputLabel>
                  <TextField
                    required
                    placeholder="67.1061"
                    className={classes.outlineInputBorder}
                    fullWidth
                    onChange={_handleOnChangeLongitude}
                    value={addCourse.longitude}
                    type={"number"}
                    variant="outlined"
                    error={!longitude && submit}
                    helperText={
                      !longitude && submit ? "Longitude is required" : ""
                    }
                  />

                  <InputLabel shrink className={classes.inputLabel}>
                    Front 9
                  </InputLabel>
                  <TextField
                    // sx={{ width: "350px" }}
                    onChange={_handleOnChangeFront9}
                    value={addCourse.front_9}
                    required
                    placeholder="Front 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Back 9
                  </InputLabel>
                  <TextField
                    onChange={_handleOnChangeBack9}
                    value={addCourse.back_9}
                    required
                    placeholder="Back 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Status
                  </InputLabel>
                  <Select
                    variant="outlined"
                    value={addCourse.status}
                    className={classes.outlineInputBorder}
                    onChange={_handleOnChangeStatus}
                    name="status"
                    fullWidth
                    label="."
                    placeholder="Active"
                  >
                    {["active", "inactive"].map((item) => (
                      <MenuItem
                        key={item}
                        // setStatus={item.name}
                        value={item}
                        onClick={() => setStatus(item)}
                      >
                        <Grid container item>
                          <Grid
                            fontStyle={{ textTransform: "capitalize" }}
                            item
                            xs={10}
                          >
                            {item}
                          </Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Select>
                  {courseDataAlert && (
                    <Alert variant="filled" severity="error">
                      {courseDetailData?.message}
                    </Alert>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </MainModal>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
